import { withInstall } from '@/utils';
import baseIcon from './src/BaseIcon.vue';
export const BaseIcon = withInstall(baseIcon);

const ctx = require.context('@/assets/svg', false, /\.svg$/);
ctx.keys().forEach((path) => {
  const temp = path.match(/\.\/([A-Za-z0-9\-_]+)\.svg$/);
  if (!temp) return;
  const name = temp[1];
  require(`@/assets/svg/${name}.svg`);
});
